import React from 'react';
import ReactDOM from 'react-dom';
import { merge, prop } from 'ramda';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import {
  resourceReducer,
  getLocale,
  loadTexts,
  loadFont,
} from '@twnel/web-components';
import { getApiHost } from '@twnel/utils-js/lib/web';
import { reducer as sessionReducer, LoginEnhancer } from '@twnel/companies-login';
import dataReducer from './data/reducer';
import visualBuilderReducer from './modules/VisualBuilder/connect/reducer';
import { GlobalStyle } from './modules/General';
import App from './modules/App';

// Toastify styles
import 'react-toastify/dist/ReactToastify.min.css';
// Datepicker styles
import 'react-datepicker/dist/react-datepicker.css';
// Common twnel css.
import '@twnel/web-components/lib/bundle.css';

import * as serviceWorker from './serviceWorker';

const { REACT_APP_VERSION, REACT_APP_TWNEL_ENV, NODE_ENV } = process.env;
const loginEnhancer = LoginEnhancer({
  environment: getApiHost() || REACT_APP_TWNEL_ENV,
  debug: NODE_ENV !== 'production',
  version: REACT_APP_VERSION,
  options: {
    includeBusinessUnits: true,
  },
});

// Compose your reducer
const reducer = combineReducers({
  ...resourceReducer, // Manage async resources e.g. localized text files
  ...sessionReducer, // Manage session data
  ...dataReducer,
  ...visualBuilderReducer,
});

// Create your redux store
const store = createStore(reducer, loginEnhancer);

// Load the texts file.
store.dispatch(
  loadTexts(async () => {
    const locale = getLocale();
    let loaders;
    switch (locale) {
      case 'es':
        loaders = [
          import('@twnel/web-components/lib/es.json'),
          import('./localization/es.json'),
        ];
        break;
      case 'pt':
        loaders = [
          import('@twnel/web-components/lib/pt.json'),
          import('./localization/pt.json'),
        ];
        break;
      default:
        return {};
    }
    const result = await Promise.all(loaders);
    return result.map(prop('default')).reduce(merge);
  }),
);

store.dispatch(
  loadFont(() => import('@twnel/web-components/lib/quicksand-regular.json')),
);

ReactDOM.render(
  // eslint-disable-next-line react/jsx-filename-extension
  <Provider store={store}>
    <GlobalStyle />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
